/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import Theme from "../../../theme/theme";
import { StyledField } from "./styles";

export interface FieldProps {
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  maxWidth?: number;
}

export const Field: FunctionComponent<FieldProps> = ({
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  maxWidth,
  children,
}) => (
  <Theme>
    <StyledField
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      maxWidth={maxWidth}
    >
      {children}
    </StyledField>
  </Theme>
);

Field.propTypes = {
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number,
  marginLeft: PropTypes.number,
  marginRight: PropTypes.number,
  maxWidth: PropTypes.number,
};

Field.defaultProps = {
  marginTop: null,
  marginBottom: null,
  marginLeft: null,
  marginRight: null,
  maxWidth: null,
};

export default Field;
